module.exports = __webpack_public_path__ + "assets/img/c75d5b6432cbe0030de780bc6522c981.svg";